/* eslint-disable better-mutation/no-mutation */

import { localStore } from 'tradera/utils/storage';
import { STORAGE_KEYS } from 'tradera/constants/storage';
import { isServer } from 'tradera/utils/nextjs';
import { parseJwt } from '../parse-jwt';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation is not compatible with SSR as global properties are shared between server instances'
    );
}

(function (w) {
    if (!w) {
        return;
    }
    let saved = null;
    let savedListener = null;
    w.onAppleNativeLogin = (err, data) => {
        if (savedListener) {
            savedListener(err, data);
        } else {
            saved = { err: err, data: data };
        }
    };
    w.onAppleNativeLoginSetListener = (listener) => {
        savedListener = listener;
        if (saved) {
            savedListener(saved.err, saved.data);
            saved = null;
        }
    };
})(window);

export default class AppleLogin {
    constructor(appleAppId) {
        !appleAppId &&
            console.error('AppleLogin.appleAppId is required but was empty');
        this.appId = appleAppId;
        this.email = null;
        this.firstName = null;
        this.lastName = null;

        const storedUser = localStore.getItem(STORAGE_KEYS.APPLE_ID_USER);
        if (storedUser) {
            this.email = storedUser.email;
            this.firstName = storedUser.name?.firstName;
            this.lastName = storedUser.name?.lastName;
        }
    }

    isLoaded() {
        return window.AppleID && !!window.AppleID.auth.init;
    }

    onNativeInitiatedLogin(callback) {
        if (!window) {
            return;
        }
        window.onAppleNativeLoginSetListener((err, data) => {
            if (err) {
                console.error('Apple Native Initiated login failed', err, data);
                this._save(null);
            } else {
                this._save(data);
                callback(data);
            }
        });
    }

    login(options = { native: false }) {
        if (window && options.native) {
            return new Promise((resolve, reject) => {
                window.onAppleNativeLoginSetListener((err, data) => {
                    if (err || !data) {
                        console.error('Apple Native login failed', err, data);
                        this._save(null);
                        reject(err ? err : 'Aborted');
                    } else {
                        if (!data.email) {
                            data.email = parseJwt(data.accessToken)?.email;
                        }
                        if (!data.userId) {
                            data.userId = parseJwt(data.accessToken)?.sub;
                        }
                        this._save(data);
                        resolve(data);
                    }
                });
                window.document.location.href =
                    'tradera://register/apple?callbackFunc=onAppleNativeLogin';
            });
        } else {
            window.AppleID.auth.init({
                clientId: this.appId,
                scope: 'name email',
                redirectURI: location.origin + '/login',
                state: '',
                usePopup: true
            });

            return window.AppleID.auth.signIn().then((signInResponse) => {
                if (signInResponse.user) {
                    this.email = signInResponse.user.email;
                    this.firstName = signInResponse.user.name.firstName;
                    this.lastName = signInResponse.user.name.lastName;
                }
                const accessToken = signInResponse.authorization?.id_token;
                if (!this.email) {
                    this.email = parseJwt(accessToken)?.email;
                }
                this.userId = accessToken && parseJwt(accessToken)?.sub;
                const data = {
                    accessToken: accessToken,
                    email: this.email,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    userId: this.userId
                };
                return data;
            });
        }
    }

    _save(data) {
        if (!data) {
            this.email = null;
            this.firstName = null;
            this.lastName = null;
        } else {
            this.email = data.email;
            this.firstName = data.firstName;
            this.lastName = data.lastName;
        }
    }
}
